module.exports = __webpack_public_path__ + "img/efl.12190f25.svg";